var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questionData.options
    ? _c(
        "div",
        { class: _vm.classes },
        _vm._l(_vm.questionData.options, function (option, index) {
          return _c(
            "div",
            { key: index, staticClass: "trbo-a-gallery__item" },
            [
              _c("gallery-item", {
                attrs: {
                  option: option,
                  "is-selected": _vm.isSelected(option),
                },
                on: { select: _vm.onSelect },
              }),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }